import type { MouseEvent } from 'react'
import { ChoiceOptionButton, RadioMark } from '../../styled-components'

interface ChoiceOptionProps {
  label: string
  selected: boolean
  onClick: (event: MouseEvent) => void
}

const ChoiceOption = ({ label, selected, onClick }: ChoiceOptionProps) => (
  <ChoiceOptionButton type='button' aria-pressed={selected} $selected={selected} onClick={onClick}>
    <RadioMark $selected={selected} aria-hidden='true' />
    {label}
  </ChoiceOptionButton>
)

export default ChoiceOption
